var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 668.00552 666.66342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #7c7c7c;\n      }\n\n      .cls-2 {\n      fill: #c6c6c6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.72455,538.47247l43.18109-43.17987c-5.59937-34.54358-27.676-66.1419-63.907-90.296-93-62-244.66535-62-338.332,0C23.33331,433.33,0,471.66333,0,512.66333s23.33331,79,65.33331,107c46.66669,31.33337,108,47.00006,169.33338,47.00006,59.18646,0,118.36981-14.5946,164.37689-43.77405l6.5968-46.87219C407.5495,563.92645,415.81567,547.38135,424.72455,538.47247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.97528,359.66333c28.33337,10.33337,54.33331,24.33337,76.66663,42,16.81469,13.53723,30.02191,28.53986,39.38806,44.50635l70.59711-70.5951C532.17133,348.46826,460.39746,342.45508,400.97528,359.66333Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.63534,0C147.302,0,76.302,71,76.302,158.33333c0,85.66664,67,155,154.33333,158a26.88874,26.88874,0,0,1,7.33334,0H240.302c85.33332-3,152.33332-72.33337,152.66663-158C392.96865,71,321.96865,0,234.63534,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M600.94869,178.00334c5.33332,64.66667-40.66668,121.33333-104.33337,129h-1.66663a15.59465,15.59465,0,0,0-5.66668.66665c-32.33332,1.66666-62-8.66662-84.33335-27.66665,34.33331-30.66666,54-76.66669,50-126.66666A154.69462,154.69462,0,0,0,429.282,80.67a119.13658,119.13658,0,0,1,42.33328-11.66667C536.94869,63.33667,595.282,112.00334,600.94869,178.00334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648.9919,458.359c-30-30-53.66668-20.33332-74,0l-118.00337,118c-4.66664,4.66664-8.99664,13.33332-9.99666,19.66667l-6.33332,45c-2.33333,16.33333,9,27.66666,25.33334,25.33334l44.99664-6.33335c6.33335-1,15.33667-5.33333,19.67-10l117.99665-118C669.32188,512.02566,678.99189,488.359,648.9919,458.359Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/manage-users.9407b9d0.svg";
export { ForwardRef as ReactComponent };